import React from 'react';
import classNames from 'classnames';
import styles from '../assets/report-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IReportPayroll } from 'src/types/reportPayroll';
import ReportPayrollActionsColumn from './ReportPayrollActionsColumn';
import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';
import dateFilter from 'src/components/react-table/filters/date-filter';
import GeneralEnum from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { CellProps } from 'react-table';

import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IReportPayroll>;
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}
const generalEnum = GeneralEnum ? GeneralEnum.getEnum('PayrollStatus') : {};
const statusTypes: SelectObject[] = getValFromEnum(generalEnum);
const columns: Column<IReportPayroll>[] = [
    {
        Header: 'Period start',
        accessor: 'periodStart',

        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IReportPayroll>) => {
            return (
                <div className={'text-center'}>
                    {original.periodStart?.date ? changeToZeroMoment(original.periodStart?.date, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilter<IReportPayroll>(),
    },
    {
        Header: 'Period End',
        accessor: 'periodEnd',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IReportPayroll>) => {
            return (
                <div className={'text-center'}>
                    {original.periodEnd?.date ? changeToZeroMoment(original.periodEnd?.date, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilter<IReportPayroll>(),
    },
    {
        Header: 'Total Payable',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'sumTotal',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IReportPayroll>) => {
            return original.sumTotal ? (
                <div className={'ml-3'}>{`$${numberWithCommas(original.sumTotal)}`}</div>
            ) : (
                <div className={'ml-3'}></div>
            );
        },
        Filter: textFilter<IReportPayroll>(),
    },

    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IReportPayroll>) => {
            const valuestatus = statusTypes.find((it) => +it.value === +original.status);

            return valuestatus ? valuestatus.label : '';
        },

        Filter: dropdownFilter<IReportPayroll>(statusTypes),
    },

    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ReportPayrollActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '20%',
    },
];

const ReportPayrollsGrid: React.FunctionComponent<Props> = ({ data, getData, getDataCsv }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IReportPayroll> columns={columns} data={data} getDataCsv={getDataCsv} getData={getData} />
    </div>
);

export default ReportPayrollsGrid;
